<div class="promocode-outer" [formGroup]="checkCouponValidityForm">
    <div class="find-outer">
        <h4>Promotional Code</h4>
        <div class="close-icon">
            <img src="assets/images/export-close.svg" (click)="cancelDialog()" alt="Close"/>
        </div>
    </div>
    <div class="code-text">
        <p>Unlock the myriad advantages within your bookings.</p>
        <div class="apply-text">
            <input pInputText pKeyFilter="int" placeholder="Enter promo code" formControlName="couponCode"/>
            <h5 *ngIf="!couponValidity?.offerStatus" (click)="CheckCouponValidity()">Apply</h5>
            <h5 *ngIf="couponValidity?.offerStatus" (click)="clearOffer()">Clear</h5>
            <div *ngIf="checkCouponValidityForm.get('couponCode').errors && checkCouponValidityForm.get('couponCode').touched" class="text-danger">
                <div  class="validation-error" *ngIf="checkCouponValidityForm.get('couponCode').hasError('required')">Coupon code is required</div>
              </div>
        </div>

    </div>
    <div class="getfree-outer">
        <img *ngIf="couponValidity?.description" src="assets/images/promo-code.png" alt=""/>

        <div class="first-booking">

            <h5 *ngIf="couponValidity?.couponCode">
                {{couponValidity?.couponCode}}
            </h5 >
            <p *ngIf="couponValidity?.summary">{{couponValidity?.summary}}</p>

        </div>
    </div>
    <div class="confirm-btn">
        <p-button label="Confirm" type="submit" [disabled]="!couponValidity?.offerStatus" (onClick)="confirmDilog()"></p-button>
        <p-button styleClass="p-button-outlined" label="No" (onClick)="cancelDialog()" ></p-button>
    </div>
</div>
